import React from "react";

import roombanner from "../assets/rooms/room.jpg";
import room1 from "../assets/images/room1.jpg";
import room3 from "../assets/images/room3.jpeg";
import room5 from "../assets/images/room5.jpeg";

const CLOUD_BEDS_RES_URL = "https://us2.cloudbeds.com/en/reservation/Lw0EvH";

const Room = () => {
  return (
    <div>
      {/* HERO + BOOKING */}
      <div
        className="relative w-full bg-no-repeat h-[300px] bg-center contrast-125 md:h-[350px] lg:h-[400px] bg-cover"
        style={{ backgroundImage: `url(${roombanner})` }}
      >
        <div className="absolute inset-0 bg-black/20 flex flex-col items-center justify-center px-4">
          <h1 className="text-center text-[#C4A484] tracking-wide font-normal text-5xl font-barlow-condensed mb-6">
            Book your stay
          </h1>

          <a
            href={CLOUD_BEDS_RES_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#0f97aa] text-white px-6 py-3 rounded-md inline-block text-center"
          >
            Book Now
          </a>
        </div>
      </div>

      {/* ROOMS */}
      <section className="mt-16 px-6 sm:px-10 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-barlow-condensed font-semibold mb-8 text-[#C4A484]">
            Double Deluxe Bungalow
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* CARD 1 */}
            <div className="max-w-md rounded-lg shadow-lg overflow-hidden">
              <img
                src={room1}
                alt="Standard Bungalow"
                className="w-full h-[300px] sm:h-[400px] object-cover"
              />
              <div className="flex justify-between items-center w-full p-6 bg-white">
                <h2 className="text-2xl font-barlow-condensed font-semibold text-[#C4A484]">
                  Bedrooms
                </h2>
              </div>
            </div>

            {/* CARD 2 */}
            <div className="max-w-md rounded-lg shadow-lg overflow-hidden">
              <img
                src={room5}
                alt="Double Deluxe Bungalow"
                className="w-full h-[300px] sm:h-[400px] object-cover"
              />
              <div className="flex justify-between items-center w-full p-6 bg-white">
                <h2 className="text-2xl font-barlow-condensed font-semibold text-[#C4A484]">
                  Bathrooms
                </h2>
              </div>
            </div>

            {/* CARD 3 */}
            <div className="max-w-md rounded-lg shadow-lg overflow-hidden">
              <img
                src={room3}
                alt="Family Bungalow"
                className="w-full h-[300px] sm:h-[400px] object-cover"
              />
              <div className="flex justify-between items-center w-full p-6 bg-white">
                <h2 className="text-2xl font-barlow-condensed font-semibold text-[#C4A484]">
                  Garden
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Room;
